(function() {
    angular
        .module('rlt')
        .directive('excludeResponsesDialog', excludeResponsesDialog);

    function excludeResponsesDialog() {
        return {
            restrict: 'E',
            templateUrl: 'components/reports/exclude/excludeResponsesView.html'
        };
    }
})();
